/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum Errors {
    NoCompanies = 'no companies',
    NoResources = 'no resources',
}
